import React from 'react';
import { SpacePage } from './pages/SpacePage';
export function App() {
  return <SpacePage data-id="element-0" />;
}